/* Second Sweep — Shelf tag theme v4
   - color chips: variant, price, price after offer, photos (hero + sections), buttons
   - photo thumbnails
   - offer end time: hides every [data-offer] after data-offer-ends (page HTML may be cached)
   - copy code, mobile menu, sticky buy bar, closing "Add to cart" button */
(function () {
  'use strict';

  function money(cents) {
    var n = Number(cents) / 100;
    var whole = Math.round(n * 100) % 100 === 0;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }

  /* ---------- Offer end ---------- */
  function offerExpired(el) {
    var ends = parseInt(el.getAttribute('data-offer-ends') || '0', 10);
    return ends > 0 && Date.now() > ends * 1000;
  }
  function applyOfferEnd() {
    var anyExpired = false;
    document.querySelectorAll('[data-offer]').forEach(function (el) {
      if (offerExpired(el)) { el.hidden = true; anyExpired = true; }
    });
    if (anyExpired) {
      document.querySelectorAll('[data-offer-off]').forEach(function (el) { el.hidden = false; });
      document.querySelectorAll('[data-product-root]').forEach(function (r) { r.setAttribute('data-offer-pct', '0'); });
      document.querySelectorAll('[data-buy-now]').forEach(function (a) { a.href = a.href.split('?')[0]; });
    }
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    var input = root.querySelector('[data-variant-input]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-option-value]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var buyNow = root.querySelector('[data-buy-now]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyColor = root.querySelector('[data-sticky-color]');

    function showImage(id) {
      images.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-media-id') === id); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-media-id') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function filterPhotos(color) {
      var first = null;
      images.forEach(function (img) {
        var c = img.getAttribute('data-color');
        var ok = !c || c === color;
        if (ok && first === null) first = img.getAttribute('data-media-id');
      });
      thumbs.forEach(function (t) {
        var c = t.getAttribute('data-color');
        t.hidden = !(!c || c === color);
      });
      if (first !== null) showImage(first);
      document.querySelectorAll('[data-color-image]').forEach(function (img) {
        img.hidden = img.getAttribute('data-color-image') !== color;
      });
    }

    function select(chip) {
      var color = chip.getAttribute('data-option-value');
      var id = chip.getAttribute('data-variant-id');
      var price = parseInt(chip.getAttribute('data-variant-price'), 10);
      var available = chip.getAttribute('data-available') === 'true';
      var pct = parseInt(root.getAttribute('data-offer-pct') || '0', 10);

      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (input) input.value = id;

      document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(price); });
      if (pct > 0) {
        var after = Math.floor(price * (100 - pct) / 100);
        document.querySelectorAll('[data-offer-price]').forEach(function (el) { el.textContent = money(after); });
      }
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyColor) stickyColor.textContent = color;

      root.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
        b.disabled = !available;
        b.textContent = available ? (b.getAttribute('data-add-text') || 'Add to cart') : 'Sold out';
      });
      if (buyNow) {
        var q = buyNow.href.indexOf('?') > -1 ? buyNow.href.slice(buyNow.href.indexOf('?')) : '';
        buyNow.href = '/cart/' + id + ':1' + q;
        buyNow.hidden = !available;
      }
      filterPhotos(color);

      if (document.body.classList.contains('template-product') && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    chips.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t.getAttribute('data-media-id')); }); });
    var active = images.filter(function (i) { return i.classList.contains('is-active'); })[0];
    if (active) showImage(active.getAttribute('data-media-id'));

    /* Sticky bar on phones once the tag's button has scrolled away */
    var sticky = root.querySelector('[data-sticky-buy]');
    var form = root.querySelector('[data-product-form]');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(form);
    }
  }

  /* ---------- Copy code ---------- */
  function initCopy() {
    document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy-code');
        var label = btn.textContent;
        var done = function () { btn.textContent = code + ' copied'; setTimeout(function () { btn.textContent = label; }, 2200); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else { done(); }
      });
    });
  }

  /* ---------- Menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = drawer.hidden;
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Close' : 'Menu';
    });
  }

  /* ---------- Closing button adds the color picked in the hero ---------- */
  function initCta() {
    document.querySelectorAll('[data-cta-buy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var form = document.querySelector('[data-product-form]');
        var btn = form && form.querySelector('[data-add-to-cart]');
        if (!form || !btn || btn.disabled) return;
        e.preventDefault();
        if (form.requestSubmit) { form.requestSubmit(btn); } else { btn.click(); }
      });
    });
  }

  /* ---------- Auto-apply a discount code (only when the offer is a code the theme applies) ---------- */
  function initCodeLink() {
    var root = document.querySelector('[data-product-root]');
    if (!root || root.getAttribute('data-offer-mode') !== 'code_link') return;
    var code = root.getAttribute('data-offer-label');
    if (!code || offerExpired(root) || !/^https?:$/.test(location.protocol) || !window.fetch) return;
    try {
      if (sessionStorage.getItem('ss_code_applied') === code) return;
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', { credentials: 'same-origin' })
        .then(function () { try { sessionStorage.setItem('ss_code_applied', code); } catch (e) {} })
        .catch(function () {});
    } catch (e) { /* storage blocked: skip */ }
  }

  function init() {
    applyOfferEnd();
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    initCopy();
    initMenu();
    initCta();
    initCodeLink();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
